import React from 'react';
import CommunicationDispatcherContainer from '../../../Container/Dashboard/CommunicationDispatcher';

const CommunicationDispatcher = () => {
  return (
    <CommunicationDispatcherContainer />
  );
};

export default CommunicationDispatcher; 